import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const measurementType = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().describe('Name of the metric, e.g. "Front pastern".'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .describe('Display and drawing order.'),

    isScalingReference: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this metric is used to establish scale.'),

    referenceLength: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Known real-world length in inches, used when this is a scaling reference.\nEach measurement set starts from this value and can override it.',
      ),

    referenceLengthOptions: z
      .string()
      .nullable()
      .optional()
      .helpText('Comma-separated inches offered in the dropdown, e.g. 6, 6.25')
      .describe(
        'Common reference lengths to offer in the measurement set\'s dropdown, as a\ncomma-separated list of inches (for example "6, 6.25" for an unshod and a\nshod front pastern). Any other value can still be typed.',
      ),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Notes about how to draw this metric.'),

    measurements: hasMany('Measurement'),
  })
  .describe(
    'An admin-defined metric the tool can capture — part of the editable starter\nset of line measurements. Carries a display order, an optional real-world\nlength, and a flag marking it as a scaling reference (front pastern, back\ncannon).',
  )
  .as('MeasurementType');

export { measurementType as measurementTypeSchema };
